// Request/response shapes mirroring cerberus handlers (src/cerberus/handlers/*.py).

export interface ApiErrorPayload {
  code?: string;
  message?: string;
}

export interface ApiError {
  error: string | ApiErrorPayload;
  code?: string;
}

export interface LoginRequest {
  email: string;
  password: string;
}

export interface TokenPair {
  access_token: string;
  refresh_token: string;
  token_type: "Bearer";
  expires_in: number;
  user_id: string;
}

export interface MfaRequired {
  mfa_required: true;
  challenge_token: string;
  user_id: string;
  expires_in: number;
  email: string;
}

export type LoginResponse = TokenPair | MfaRequired;

export function isMfaRequired(r: LoginResponse): r is MfaRequired {
  return "mfa_required" in r && r.mfa_required === true;
}

export interface SignupRequest {
  email: string;
  password: string;
  display_name: string;
  locale?: string;
  return_to?: string;
}

export interface SignupResponse {
  user_id: string;
  email: string;
  status: string;
}

export interface MfaChallengeRequest {
  challenge_token: string;
  user_id: string;
  code: string;
}

export interface PasswordResetRequestBody {
  email: string;
}

export interface PasswordResetConfirmBody {
  token: string;
  user_id: string;
  new_password: string;
}

export interface MfaEnrollResponse {
  secret_b32: string;
  otpauth_url: string;
  qr_data_url: string;
  backup_codes: string[];
}

export interface MfaVerifyRequest {
  code: string;
}

export interface VerifyResponse {
  user_id: string;
  status: string;
}
